import { Link } from "react-router-dom";
function Staff() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item"> Facilities</li>
          <li className="breadcrumb-item active">Staff</li>
        </ul>
      </div>
      <div className="innersec container my-5">
        <div className="row g-3 facilities_section_imgs">
          <div class="col-lg-12">
            <h1> Staff </h1>
            <p>
              School staff play a vital role in maintaining a supportive and
              efficient learning environment by providing guidance, instruction,
              administration, and care, working collaboratively to ensure
              students’ academic growth, well-being, and the smooth functioning
              of all school activities and operations.
            </p>
          </div>
        </div>
        <br />

        <div className="row g-3 facilities_section_imgs">
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Admin.JPG"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>

          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Teaching.JPG"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default Staff;
